module.exports = __webpack_public_path__ + "img/unmarked-icon.9211eb81.svg";